import type { IconProps } from './../../models/icon';

export function SwedenFlagIcon({
  width = 36,
  height = 26,
  className,
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 36 26"
      width={width}
      height={height}
      className={className}
    >
      <rect width="35.1" height="25.5" fill="#F6CF46" />
      <rect width="10.4" height="11" y="14.5" fill="#2D69A4" />
      <rect width="20.7" height="11" x="14.4" y="14.5" fill="#2D69A4" />
      <rect width="20.7" height="10.5" x="14.4" fill="#2D69A4" />
      <rect width="10.4" height="10.5" fill="#2D69A4" />
    </svg>
  );
}
